var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/alejandro.lorenzo/Desktop/Projects/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/browsers.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-browsers\">\r\n\t<h1 class=\"page-header\">Browsers</h1>\r\n\t<div id=\"filters\"></div>\r\n\t<div class=\"cm-browsers-flex\">\r\n\t\t<div>\r\n\t\t\t<h2>Top browser families</h2>\r\n\t\t\t<div id=\"browsers\" class=\"cm-table\"></div>\r\n\t\t</div>\r\n\t\t<div>\r\n\t\t\t<h2>Top devices</h2>\r\n\t\t\t<div id=\"device\" class=\"cm-table\"></div>\r\n\t\t</div>\r\n\t\t<div>\r\n\t\t\t<h2>Top operation systems</h2>\r\n\t\t\t<div id=\"os\" class=\"cm-table\"></div>\r\n\t\t</div>\r\n\t</div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/browsers.html"] , dependencies)